import { Box, Card, styled, Typography } from '@mui/material'

import { isDesktopUp } from '../../theme/deviceChecks'

interface StyledCardProps {
  hasEntitlementSplit: boolean | undefined
  loading?: boolean
  topColor?: string
  bottomColor?: string
  radius?: string
}

export const EntitlementCard = styled(Card, {
  shouldForwardProp: prop => prop !== 'hasEntitlementSplit',
})<StyledCardProps>`
  &.MuiCard-root {
    position: relative;
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: row;
    overflow: visible;
    ${({ hasEntitlementSplit, topColor, bottomColor, radius }) => {
      if (hasEntitlementSplit === undefined) {
        return `background: #fff;`
      }
      const splitPercentage = topColor || bottomColor ? '55' : '60'
      return `background: ${
        hasEntitlementSplit
          ? `linear-gradient(to bottom, ${topColor || 'white'} ${splitPercentage}%, ${
              bottomColor || '#20c5a0'
            } 0%)`
          : 'linear-gradient(to right, white 55%, #20c5a0 0%)'
      };`
    }}
    padding: 16px 20px;
    height: 98px;
    border-radius: ${({ radius }) => radius || '16px'};
    box-shadow: none;
  }
`

export const StyledNumbers = styled(Box, {
  shouldForwardProp: prop => prop !== 'hasEntitlementSplit',
})<StyledCardProps>`
  font-family: Poppins;
  font-weight: 400;
  ${({ hasEntitlementSplit }) => `color: ${hasEntitlementSplit ? '#20C5A0' : '#fff'};`}
  font-size: 22px;
  margin-right: 0px;
`

export const StyledDescriptor = styled(Typography)`
  &.MuiTypography-root {
    font-family: Poppins;
    font-weight: bold;
    color: #000;
    font-size: 13px;
    line-height: 1.5;
  }

  ${isDesktopUp()} {
    &.MuiTypography-root {
      font-size: 0.67vw;
    }
  }
`
